import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class PigmyAccountService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'pigmyaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'pigmyaccount').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  get(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'pigmyaccount/customer').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `pigmyaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(pigmyAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'pigmyaccount', pigmyAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(pigmyAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'pigmyaccount', pigmyAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(pigmyAccount: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'pigmyaccount/authorise', pigmyAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `pigmyaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getPigmyAgentAccounts(agentId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `pigmyaccount/agent/${agentId}
    `).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  pigmyCollection(collectionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `pigmyaccount/collection`, collectionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computePenalty(computePenalty: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'pigmyaccount/penalty', computePenalty).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  saveWithdrawalOrClosure(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'pigmyaccount/withdrawal', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
 
  exportMachineData(agentId: number): Observable<any> {
    return this.httpClient.get<Blob>(this.baseApiUrl + `machine/export/${agentId}`,{observe: 'response', responseType: 'blob' as 'json' });
  }

  sendImportFormData(agentId: number,machineType: number,data: FormData): Observable < any > {
    data.forEach((value,key) => {
      console.log(key+" "+value);
    });
    return this.httpClient.post < any > (this.baseApiUrl + `machine/import/upload/${agentId}/${machineType}`, data).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }  

  pigmySaveImportData(selectedRowsData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `machine/import`, selectedRowsData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}